<template>
  <div class="ds-control ds-platform-card-box" :class="{'un-fix-column-number':!fixColumnNumber}" :style="boxStyle" v-onresize="onObserveResize">
    <div class="ds-platform-card-header">
      <slot v-if="checkbox && showCheckAll && maxCheckNum !== 1" name="all-select" :owner="self">
        <dsf-custom-checkbox
          class="ds-platform-card-box-checkAll"
          :class="[checkboxSize]"
          :value="checkAll"
          :indeterminate="isIndeterminate"
          size="small"
          @change="handleCheckAllChange($event)"
          :style="{marginLeft:fixColumnNumber?0:mTop}">
          全选
        </dsf-custom-checkbox>
      </slot>
    </div>
    <div v-if="isDesign" class="ds-platform-card-list" :class="[checkboxPosition]">
      <div class="ds-platform-card-item no-margin-left no-margin-top" :style="itemStyle" slot-name="default">
        <div class="ds-platform-card-item-content">
          <slot v-bind="{ row: {}, $index: 0 }"></slot>
        </div>
        <dsf-custom-checkbox v-if="checkbox && checkboxStyle" :style-type="checkboxStyle" :size="checkboxSize" class="ds-platform-card-item-checkbox" />
      </div>
      <template v-for="$index in (columnNumberReal - 1)">
        <div :key="$index" class="ds-platform-card-item no-margin-top" :style="itemStyle">
          <dsf-custom-checkbox v-if="checkbox && checkboxStyle" :style-type="checkboxStyle" :size="checkboxSize" class="ds-platform-card-item-checkbox" />
        </div>
      </template>
    </div>
    <div v-else-if="!realData.length" class="ds-platform-card-list" :class="[checkboxPosition, {'is-empty': !realData.length}]">
      <!-- <div class="ds-empty-data" text="暂无数据" style="max-height: 500px"></div> -->
      <dsf-empty-data></dsf-empty-data>
    </div>
    <div v-else class="ds-platform-card-body" @scroll="onScroll">
      <div class="ds-platform-card-list" :class="[checkboxPosition]">
        <template v-for="(row, $index) in realData">
          <div
            :key="row[rowKey]"
            class="ds-platform-card-item"
            :class="{
              'no-margin-left': fixColumnNumber && !($index % columnNumberReal),
              'no-margin-top': fixColumnNumber && $index < columnNumberReal,
            }"
            :style="itemStyle">
            <div class="ds-platform-card-item-content" @contextmenu="contextmenu(row, $index, $event)">
              <slot v-bind="{ row, $index }"></slot>
            </div>
            <slot v-if="checkbox && checkboxStyle" name="select" :owner="self" :row="row" :$index="$index">
              <dsf-custom-checkbox class="ds-platform-card-item-checkbox" :value="checkIdList.indexOf(row[rowKey]) > -1" :style-type="checkboxStyle" :size="checkboxSize" :disabled="selectableHandler(row, $index) === false" @input="checkChange(row, $event)" />
            </slot>
          </div>
        </template>
        <slot name="append"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfPlatformCardBox",
  ctrlCaption: "卡片列表",
  mixins: [$mixins.cardList],
  props: {
    // big, medium, small
    checkboxSize: {
      type: String,
      default: "medium"
    },
    // 选择框位置
    checkboxPosition: {
      type: String,
      default: "top right"
    },
    // 固定列数
    fixColumnNumber: {
      type: Boolean,
      default: true,
    },
    // 不固定列时的最大宽度
    columnMaxWidth: {
      type: String,
      default: "30%"
    },
    // 不固定列时的最小宽度
    columnMinWidth: {
      type: String,
      default: "30%"
    }
  },
  data() {
    return {
      self: this,
      columnNumberAuto: 1,  //可变的列数
      columnWidthAuto: 0  //可变的列宽
    }
  },
  watch: {
    columnNumber(v) {
      if (this.isDesign) {
        if (v > 1) {
          this.columnWidth = Math.floor(100 / v) - 1 + "%";
        } else {
          this.columnWidth = "100%";
        }
      }
    },
    fixColumnNumber(n,o){
      if(n!=o && n && this.isDesign){
        let v = this.columnNumber;
        if (v > 1) {
          this.columnWidth = Math.floor(100 / v) - 1 + "%";
        } else {
          this.columnWidth = "100%";
        }
      }else if(!n){
        this.setAutoData();
      }
    },
    columnMinWidth(){
      this.setAutoData();
    },
    columnMaxWidth(){
      this.setAutoData();
    }
  },
  methods: {
    onScroll(e) {
      this.$emit('scroll', e);
    },
    onObserveResize(entry) {
      // 监听卡片式宽度变化
      if (entry) {
        let {contentRect: { width: elWidth }} = entry;
        this.setAutoData(_.round(elWidth));
      }
    },
    // 页面宽度变化的时候-重新计算列数和列宽
    setAutoData() {
      if (this.fixColumnNumber || !this.$el) return;

      function getPxNum(data) {
        if (data) {
          if (data.endsWith("%")) {
            return box_width_px * parseFloat(data) / 100;
          } else if (data.endsWith("px")) {
            return parseFloat(data);
          }
        }
        return data;
      }

      let box_width_px = this.$el.getElementsByClassName("ds-platform-card-list")[0].clientWidth;
      let margin_left_px_v = getPxNum(this.mTop) || 0;
      let min_width_px_v = getPxNum(this.columnMinWidth);
      let max_width_px_v = getPxNum(this.columnMaxWidth);
      // 最多可以放的数量
      let min_width_col_num = Math.floor(min_width_px_v ? box_width_px / (min_width_px_v + margin_left_px_v) : 1);
      // 最少可以放的数量
      let max_width_col_num = max_width_px_v ? box_width_px / (max_width_px_v + margin_left_px_v) : 1;
      this.columnNumberAuto = min_width_col_num || 1;

      if (min_width_px_v && min_width_px_v === max_width_px_v) {
        this.columnWidthAuto = min_width_px_v + "px";
        this.columnNumberAuto = Math.floor(box_width_px / min_width_px_v);
      } else {
        this.columnWidthAuto = (box_width_px / min_width_col_num) - margin_left_px_v + "px";
      }
    },
    contextmenu(row, $index, event) {
      this.$emit('on-contextmenu', {row, $index, event});
    }
  },
  computed: {
    // 获取真正的当前展示列数
    columnNumberReal(){
      if(this.fixColumnNumber){
        return this.columnNumber;
      }else {
        return this.columnNumberAuto;
      }
    },
    itemStyle() {
      let res = {
        "width": this.cWidth,
        "margin-top": this.mTop,
        "margin-left": this.marginLeft,
        "min-width": this.columnMinWidth || "auto",
        "max-width": this.columnMaxWidth || "auto",
      }

      if (!this.horizontal) {
        if (this.fixColumnNumber) {
          // 固定列数
          res["margin-left"] = `calc((100% - ${this.cWidth} * ${this.columnNumber}) / ${this.columnNumber - 1})`;
          delete res["min-width"];
          delete res["max-width"];
        } else {
          // 不固定列数
          if(!this.columnWidthAuto){
            this.setAutoData();
          }
          res["margin-left"] = this.mTop;
          res.width = this.columnWidthAuto;
        }
      }

      if (this.horizontal) {
        res['height'] = this.lHeight;
      }
      return res;
    },
    boxStyle(){
      if(!this.fixColumnNumber && this.mTop){
        return {
          paddingRight: this.mTop
        }
      }
      return {};
    }
  }
});
</script>